import { render, staticRenderFns } from "./Blogpage.vue?vue&type=template&id=37342ef0&scoped=true&v-bind%3Akey=%24route.path&"
import script from "./Blogpage.vue?vue&type=script&lang=js&"
export * from "./Blogpage.vue?vue&type=script&lang=js&"
import style0 from "./Blogpage.vue?vue&type=style&index=0&id=37342ef0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37342ef0",
  null
  
)

export default component.exports